import React from "react"

export default Object.freeze({
  all: "すべて",
  "about the author": "著者について",
  "remove cookies": "クッキーを削除",
  "accept cookies": "クッキーを受け入れる",
  search: "検索",
  "see how we help higher education": (
    <span>
      私たちが高等教育をどのように支援するかを見てください
    </span>
  ),
  "see how we help business": (
    <span>
      私たちがビジネスをどのように支援するかを見てください
    </span>
  ),
  "see what EDU customers say about us": (
    <span>
      EDUのお客様が私たちについてどう思うかを見てください
    </span>
  ),
  "see what WORK customers say about us": (
    <span>
      お客様の声を見る
    </span>
  ),
  "case study": "事例研究",
  blog: "ブログ",
  industries: "業界",
  "case studies": "事例研究",
  resources: "リソース",
  listing: "リスト",
  register: "登録",
  "find out more": "詳細を見る",
  "past events": "過去のイベント",
  "read more": "もっと読む",
  page: "ページ",
  previous: "前へ",
  next: "次へ",
  tip: "ヒント",
  "no items found": "アイテムが見つかりません",
  categories: "カテゴリ",
  by: "によって",
  events: "イベント",
  "link to": "リンク",
  oops: "Oops...",
  "page not found message": "このコンテンツは利用できません。代わりに以下のコンテンツをご覧ください:",
  "event passed": "イベントは終了しました",
  "business we work with": "私たちがビジネスを支援する方法",
  "education we work with": "私たちが高等教育を支援する方法",
  "back to homepage": "ホームページに戻る",
  "try it free": "無料で試す",
  "book a demo": "デモを予約する",
})
